import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from '../../services/analyticsService';

/**
 * Component that tracks page views when routes change
 * This component doesn't render anything, it just tracks route changes
 */
const RouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search);
  }, [location]);

  // This component doesn't render anything
  return null;
};

export default RouteTracker;
